// 实名认证审核 Mock（对齐数据库用户模块的实名认证表）
// 界面不暴露表名/字段名
//
// 审核链路：C 端用户在小程序提交姓名 + 证件照片 → 后台进入「待审核」
//   → 运营核对证件照片与填写信息 → 通过（用户获得已认证身份）/ 驳回（必须填原因，用户端可见并可重新提交）
// 身份证号在库中加密存储，列表与详情一律脱敏展示，仅保留前 3 位与后 4 位。

export const AUTH_STATUS = [
  { label: '待审核', value: 0 },
  { label: '已通过', value: 1 },
  { label: '已驳回', value: 2 }
]

export function authStatusText(status) {
  const hit = AUTH_STATUS.find(s => s.value === status)
  return hit ? hit.label : '未知'
}

export function authStatusTagType(status) {
  if (status === 1) return 'success'
  if (status === 2) return 'danger'
  return 'warning'
}

// 驳回常用理由，点选后仍可编辑
export const REJECT_REASONS = [
  '证件照片模糊或反光，请重新上传',
  '证件照片不完整，四角有遮挡',
  '姓名与证件信息不一致',
  '证件已过有效期',
  '填写的证件号码有误',
  '证件信息与本人不符'
]

// 身份证号脱敏：保留前 3 位与后 4 位
export function maskIdCard(no) {
  const s = String(no || '')
  if (s.length <= 7) return s
  return s.slice(0, 3) + '*'.repeat(s.length - 7) + s.slice(-4)
}

// 证件照占位图（浅暖灰示意稿，接入对象存储后由真实照片覆盖）
function idCardPlaceholder(side) {
  const isFront = side === 'front'
  const body = isFront
    ? `<rect x="24" y="56" width="60" height="76" rx="4" fill="#eae1d1" stroke="#dbcfb9"/>
       <circle cx="54" cy="84" r="14" fill="#cdc0a8"/>
       <path d="M34 132c0-12 9-21 20-21s20 9 20 21z" fill="#cdc0a8"/>
       <rect x="102" y="62" width="92" height="9" rx="4.5" fill="#ded2bd"/>
       <rect x="102" y="84" width="140" height="7" rx="3.5" fill="#e6ddcd"/>
       <rect x="102" y="102" width="118" height="7" rx="3.5" fill="#e6ddcd"/>
       <rect x="102" y="120" width="150" height="7" rx="3.5" fill="#e6ddcd"/>`
    : `<circle cx="88" cy="94" r="36" fill="none" stroke="#dbcfb9" stroke-width="2"/>
       <circle cx="88" cy="94" r="24" fill="#eae1d1"/>
       <path d="M88 80l3.6 7.6 8.4 1-6.2 5.8 1.6 8.3L88 98.8l-7.4 3.9 1.6-8.3-6.2-5.8 8.4-1z" fill="#c9bba1"/>
       <rect x="148" y="80" width="104" height="8" rx="4" fill="#ded2bd"/>
       <rect x="148" y="100" width="126" height="7" rx="3.5" fill="#e6ddcd"/>`
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="300" height="190" viewBox="0 0 300 190">
    <rect width="300" height="190" rx="10" fill="#f6f1e8"/>
    <rect x="0.5" y="0.5" width="299" height="189" rx="10" fill="none" stroke="#e6ddcd"/>
    ${body}
    <text x="150" y="170" text-anchor="middle" font-size="12" font-family="sans-serif" fill="#bcae96">证件${isFront ? '人像面' : '国徽面'}</text>
  </svg>`
  return 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svg)
}

export const ID_CARD_FRONT = idCardPlaceholder('front')
export const ID_CARD_BACK = idCardPlaceholder('back')

// 认证申请列表（字段对齐实名认证表：user_id / real_name / id_card_no / 证件照 / status / reject_reason / audit_at）
export const USER_AUTH_LIST = [
  // 待审核
  {
    id: 5001, user_id: 105, nickname: '梅子黄时雨', gender: 2, phone: '159****2277',
    real_name: '王雨薇', id_card_no: '430102199204155627',
    id_card_front: ID_CARD_FRONT, id_card_back: ID_CARD_BACK,
    status: 0, reject_reason: '', audit_at: null, created_at: '2026-09-11 09:20:41'
  },
  {
    id: 5002, user_id: 108, nickname: '稻香人家', gender: 2, phone: '135****9034',
    real_name: '沈丽君', id_card_no: '320583199508220341',
    id_card_front: ID_CARD_FRONT, id_card_back: ID_CARD_BACK,
    status: 0, reject_reason: '', audit_at: null, created_at: '2026-09-11 08:12:07'
  },
  {
    id: 5003, user_id: 113, nickname: '南音未歇', gender: 2, phone: '177****8813',
    real_name: '林南音', id_card_no: '350582199711064488',
    id_card_front: ID_CARD_FRONT, id_card_back: ID_CARD_BACK,
    status: 0, reject_reason: '', audit_at: null, created_at: '2026-09-10 21:44:29'
  },
  {
    id: 5004, user_id: 110, nickname: '小满未满', gender: 2, phone: '188****3329',
    real_name: '贺晓满', id_card_no: '420106199309121532',
    id_card_front: ID_CARD_FRONT, id_card_back: ID_CARD_BACK,
    status: 0, reject_reason: '', audit_at: null, created_at: '2026-09-10 15:06:53'
  },
  // 已通过
  {
    id: 5005, user_id: 103, nickname: '清风入竹', gender: 1, phone: '137****8890',
    real_name: '李明远', id_card_no: '330106198802253319',
    id_card_front: ID_CARD_FRONT, id_card_back: ID_CARD_BACK,
    status: 1, reject_reason: '', audit_at: '2026-09-09 10:22:18', created_at: '2026-09-09 09:47:36'
  },
  {
    id: 5006, user_id: 106, nickname: '塔林常客·老周', gender: 1, phone: '136****4408',
    real_name: '周建国', id_card_no: '440106197511308812',
    id_card_front: ID_CARD_FRONT, id_card_back: ID_CARD_BACK,
    status: 1, reject_reason: '', audit_at: '2026-09-08 16:35:02', created_at: '2026-09-08 14:20:11'
  },
  {
    id: 5007, user_id: 101, nickname: '塔塔得旅行日记', gender: 2, phone: '138****6216',
    real_name: '赵芸', id_card_no: '370781199601143366',
    id_card_front: ID_CARD_FRONT, id_card_back: ID_CARD_BACK,
    status: 1, reject_reason: '', audit_at: '2026-09-07 11:08:45', created_at: '2026-09-07 09:31:20'
  },
  {
    id: 5008, user_id: 109, nickname: '行走的老树', gender: 1, phone: '150****5561',
    real_name: '孟德海', id_card_no: '510107196905217758',
    id_card_front: ID_CARD_FRONT, id_card_back: ID_CARD_BACK,
    status: 1, reject_reason: '', audit_at: '2026-09-05 15:52:09', created_at: '2026-09-05 13:16:44'
  },
  {
    id: 5009, user_id: 111, nickname: '桂林·接引小站', gender: 0, phone: '',
    real_name: '秦砚', id_card_no: '450305199003071244',
    id_card_front: ID_CARD_FRONT, id_card_back: ID_CARD_BACK,
    status: 1, reject_reason: '', audit_at: '2026-09-03 09:41:57', created_at: '2026-09-03 08:55:12'
  },
  // 已驳回
  {
    id: 5010, user_id: 104, nickname: '南山悠然客', gender: 0, phone: '',
    real_name: '疏影', id_card_no: '610113199408265516',
    id_card_front: ID_CARD_FRONT, id_card_back: ID_CARD_BACK,
    status: 2, reject_reason: '证件照片模糊或反光，请重新上传', audit_at: '2026-09-06 10:03:26', created_at: '2026-09-06 09:12:38'
  },
  {
    id: 5011, user_id: 112, nickname: '云深不知处', gender: 1, phone: '139****6650',
    real_name: '陆惊鸿', id_card_no: '610103199212304471',
    id_card_front: ID_CARD_FRONT, id_card_back: ID_CARD_BACK,
    status: 2, reject_reason: '姓名与证件信息不一致', audit_at: '2026-09-04 17:29:11', created_at: '2026-09-04 16:02:50'
  },
  {
    id: 5012, user_id: 114, nickname: '远山淡影', gender: 0, phone: '133****2047',
    real_name: '段云舟', id_card_no: '530102199810125533',
    id_card_front: ID_CARD_FRONT, id_card_back: ID_CARD_BACK,
    status: 2, reject_reason: '证件已过有效期', audit_at: '2026-09-02 14:47:33', created_at: '2026-09-02 11:25:04'
  }
]
